import { Link } from '@inertiajs/react'
import Layout from '../Layout'

interface Account {
  id: number
  name: string
  slug: string
}

interface Category {
  id: number
  name: string
}

interface Props {
  category: Category
  account: Account
  permissions?: {
    can_manage_categories: boolean
  }
}

export default function CategoriesShow({ category, account, permissions }: Props) {
  return (
    <Layout account={account} permissions={permissions}>
      <div className="max-w-md mx-auto">
        <h1 className="text-2xl font-bold text-[#202020] mb-6">{category.name}</h1>
        <Link href={`/${account.slug}/categories`} className="text-[#55ACEE] hover:underline">
          Volver a categorías
        </Link>
      </div>
    </Layout>
  )
}
